export default __webpack_public_path__ + "static/media/eye.1d7c3ef0.gif";